import { ErrorStateMatcher } from '@angular/material/core';
import {
    BooleanFilter,
    DateFilter,
    DateRangeFilter,
    Filter,
    MultilineTextFilter,
    MultiSelectFilter,
    NumberFilter,
    SelectFilter,
    StringFilter,
    TimeFilter,
} from '@models/filter-types';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';

export class FilterInputErrorStateMatcher<T> implements ErrorStateMatcher {
    constructor(
        private property:
            | SelectFilter<T>
            | MultiSelectFilter<T>
            | NumberFilter
            | StringFilter
            | DateFilter
            | DateRangeFilter
            | BooleanFilter
            | TimeFilter
            | MultilineTextFilter
            | Filter<T>,
    ) {}

    isErrorState(_control: FormControl | null, _form: FormGroupDirective | NgForm | null): boolean {
        return !this.property?.isValid;
    }
}
